import { useApi } from '@/api';
import { EntityName, Page, PageSkeleton, SelectFilter } from '@/components';
import { FARM_CHRONICLE_EVENTS, FARM_EVENTS } from '@/constants';
import { farmMapping } from '@/utils/farms';
import { tokensMapping } from '@/utils/tokens';
import { CryptoIcon, Flex, Heading, useTableProps } from '@blockanalitica/ui';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import FarmEventsTable from './EventsTable';
import HistoricTabs from './HistoricTabs';

export default function StakeActivityPage() {
  const { address } = useParams();

  const { pagination, sorting, filters } = useTableProps({
    pageSize: 10,
    initialSorting: '-debt',
    filtersDebounceTime: 50
  });

  const event_mapping =
    farmMapping(address) !== 'chronicle_farm'
      ? FARM_EVENTS
      : FARM_CHRONICLE_EVENTS;

  const selectFilterOptions = useMemo(() => {
    const options = [{ label: 'All events', value: '' }];
    options.push(
      ...Object.entries(event_mapping).map(([key, value]) => ({
        label: value,
        value: key,
        selected: key === filters.filtersApplied.eventType
      }))
    );
    return options;
  }, [event_mapping, filters]);

  const [currency, reward_token] = (() => {
    switch (farmMapping(address)) {
      case 'sky_farm':
        return ['Rewards', 'SKY'];
      case 'chronicle_farm':
        return ['Points', 'CHRON'];
      case 'spk_farm':
        return ['Rewards', 'SPK'];
      default:
        return ['Rewards', 'USDS'];
    }
  })();

  const [data, error] = useApi({
    url: `/farms/${address}/`
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Page
        title={
          <EntityName
            symbol1={
              <CryptoIcon
                name={data.staking_token_symbol}
                address={data.staking_token_address}
                size="3"
              />
            }
            symbol2={
              <CryptoIcon
                name={tokensMapping(reward_token).name}
                address={tokensMapping(reward_token).address}
                size="3"
              />
            }>
            <Heading size="1">{currency} Activity</Heading>
          </EntityName>
        }
        actions={[]}>
        <HistoricTabs address={address} />
        <Flex justifyContent="space-between" alignItems="center">
          <Heading size="3">Events</Heading>
          <SelectFilter
            key="event-filter"
            filterField="eventType"
            options={selectFilterOptions}
            pagination={pagination}
            {...filters}
          />
        </Flex>
        <FarmEventsTable
          address={address}
          pagination={pagination}
          sorting={sorting}
          filters={filters}
        />
      </Page>
    );
  }

  return <PageSkeleton />;
}
